import * as React from 'react';
import { Checkbox as BaseCheckbox } from '@base-ui/react/checkbox';
import { Check, Minus } from 'lucide-react';
import { cn } from '../../lib/utils';

export type CheckboxProps = React.ComponentPropsWithoutRef<typeof BaseCheckbox.Root>;

/**
 * Token-styled checkbox on the Base UI Checkbox (`role="checkbox"`, Space to
 * toggle, a hidden input for forms). Name it with `<Label htmlFor={id}>` or
 * `aria-label`. `onCheckedChange(checked)` replaces the native `onChange`.
 */
const Checkbox = React.forwardRef<HTMLElement, CheckboxProps>(
  ({ className, indeterminate, ...props }, ref) => (
    <BaseCheckbox.Root
      ref={ref}
      {...(indeterminate === undefined ? {} : { indeterminate })}
      className={cn(
        'peer inline-flex size-4 shrink-0 items-center justify-center rounded-sm border border-input bg-background text-primary-foreground ring-offset-background',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        'data-[checked]:border-primary data-[checked]:bg-primary data-[indeterminate]:border-primary data-[indeterminate]:bg-primary',
        'data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50',
        className,
      )}
      {...props}
    >
      <BaseCheckbox.Indicator className="flex items-center justify-center">
        {indeterminate ? (
          <Minus className="size-3" aria-hidden="true" />
        ) : (
          <Check className="size-3" aria-hidden="true" />
        )}
      </BaseCheckbox.Indicator>
    </BaseCheckbox.Root>
  ),
);
Checkbox.displayName = 'Checkbox';

export { Checkbox };
